import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Map, Set } from 'immutable';
import isarray from 'isarray';
import { fetchSubmission } from '../../../apis';
import { I18nContext } from './I18nContext';
var submissionContexts = {};
export var I18n = /*#__PURE__*/function (_React$Component) {
  _inherits(I18n, _React$Component);

  var _super = _createSuper(I18n);

  function I18n(props) {
    var _this;

    _classCallCheck(this, I18n);

    _this = _super.call(this, props);
    _this.state = {
      loading: !!props.submissionId,
      context: props.context
    };
    return _this;
  }

  _createClass(I18n, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.state.loading) {
        // If submissionId is passed in, we need to fetch the submission to build the context
        if (this.props.submissionId) {
          // If submission was already fetched, use previous result
          if (submissionContexts.hasOwnProperty(this.props.submissionId)) {
            this.setState(function (state) {
              return {
                loading: false,
                context: submissionContexts[_this2.props.submissionId] || _this2.state.context
              };
            });
          } else {
            // Otherwise fetch the submission
            fetchSubmission({
              id: this.props.submissionId,
              datastore: !!this.props.datastore,
              include: 'form,form.kapp'
            }).then(function (_ref) {
              var submission = _ref.submission;
              // Build context using submission data
              var context = submission ? !!_this2.props.datastore ? "datastore.forms.".concat(submission.form.slug) : "kapps.".concat(submission.form.kapp.slug, ".forms.").concat(submission.form.slug) : null; // Store the context for the submissionId

              submissionContexts[_this2.props.submissionId] = context; // Update loading state to false and set correct context

              _this2.setState(function (state) {
                return {
                  loading: false,
                  context: context || _this2.state.context
                };
              });
            });
          }
        } else {
          this.setState(function (state) {
            return _objectSpread(_objectSpread({}, state), {}, {
              loading: false
            });
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return !this.state.loading ? /*#__PURE__*/React.createElement(I18nContext.Consumer, null, function (_ref2) {
        var context = _ref2.context,
            locale = _ref2.locale,
            translations = _ref2.translations,
            loadTranslations = _ref2.loadTranslations;

        // If render funtion is passed, or children is a string or array of strings,
        // return the translation of the children string
        if (typeof _this3.props.render === 'function' || typeof _this3.props.children === 'string' || isarray(_this3.props.children) && _this3.props.children.every(function (c) {
          return typeof c === 'string';
        })) {
          return /*#__PURE__*/React.createElement(I18nTranslate, {
            context: _this3.state.context || context,
            locale: locale,
            translations: translations,
            loadTranslations: loadTranslations,
            "public": _this3.props["public"],
            render: _this3.props.render
          }, _this3.props.children);
        } // Otherwise wrap children in a new instance of I18nProvider with the new context
        else if (_this3.state.context) {
            return /*#__PURE__*/React.createElement(I18nContext.Provider, {
              value: {
                context: _this3.state.context,
                locale: locale,
                translations: translations,
                loadTranslations: loadTranslations
              }
            }, /*#__PURE__*/React.createElement(I18nTranslate, {
              context: _this3.state.context,
              locale: locale,
              translations: translations,
              loadTranslations: loadTranslations,
              "public": _this3.props["public"]
            }, _this3.props.children));
          } // Otherwise return children
          else {
              return _this3.props.children;
            }
      }) : null;
    }
  }]);

  return I18n;
}(React.Component);
export var I18nTranslate = /*#__PURE__*/function (_React$Component2) {
  _inherits(I18nTranslate, _React$Component2);

  var _super2 = _createSuper(I18nTranslate);

  function I18nTranslate() {
    _classCallCheck(this, I18nTranslate);

    return _super2.apply(this, arguments);
  }

  _createClass(I18nTranslate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadTranslations(this.props.locale, this.props.context, this.props["public"]);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.context !== prevProps.context || this.props.locale !== prevProps.locale) {
        this.props.loadTranslations(this.props.locale, this.props.context, this.props["public"]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.translations.hasIn([this.props.locale, this.props.context])) {
        if (typeof this.props.render === 'function') {
          return this.props.render(translate(this.props));
        } else if (typeof this.props.children === 'string') {
          return translate(this.props)(this.props.children);
        } else if (isarray(this.props.children) && this.props.children.every(function (c) {
          return typeof c === 'string';
        })) {
          return translate(this.props)(this.props.children.join(''));
        } else {
          return this.props.children;
        }
      } else {
        //TODO:I changed this because translations doesn't exist in the SPUI yet.
        return typeof this.props.children === 'string' ? this.props.children : null;
      }
    }
  }]);

  return I18nTranslate;
}(React.Component);

var translate = function translate(_ref3) {
  var context = _ref3.context,
      locale = _ref3.locale,
      translations = _ref3.translations;
  return function (key) {
    trackKeys(context, key);

    if (window.highlightTranslations) {
      // Surround translated text with asterisks to easily see what's wrapped
      return "*".concat(translations.getIn([locale, context, key]) || translations.getIn([locale, 'shared', key]) || key, "*");
    } else {
      return translations.getIn([locale, context, key]) || translations.getIn([locale, 'shared', key]) || key;
    }
  };
};

var trackedKeys = Map();

var trackKeys = function trackKeys(context, key) {
  trackedKeys = trackedKeys.has(key) ? trackedKeys.set(key, trackedKeys.get(key).add(context)) : trackedKeys.set(key, Set([context]));
  window.bundle = window.bundle || {};
  window.bundle.config = window.bundle.config || {};
  window.bundle.config.translationKeys = trackedKeys.toJS();
};